import {
  LifecycleStatus,
  SupplyStatus,
  UnitSituation,
  UnitType,
} from '@seller-area/components/molecules/customer-panel/customer-panel-table/types';
export { PRODUCT_LABEL, SUBMARKET_LABEL } from '@seller-area/utils/translators/unit';

export const TWO_DIGITS_OPTS: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
export const FOUR_DIGITS_OPTS: Intl.NumberFormatOptions = { minimumFractionDigits: 4, maximumFractionDigits: 4 };
export const NO_DIGITS_OPTS: Intl.NumberFormatOptions = { maximumFractionDigits: 0 };

export const STATUS_LABEL: Record<LifecycleStatus, string> = { LEAD: 'Lead', CUSTOMER: 'Cliente', CHURN: 'Churn' };
// Sentinel used as the status column-filter option value for "no status" (status IS NULL).
export const STATUS_NULL_FILTER = '__NULL__' as const;
export const TYPE_LABEL: Record<UnitType, string> = {
  COMERCIAL: 'Comercial',
  INDUSTRIAL: 'Industrial',
  OUTROS: 'Outros',
};
export const SUPPLY_LABEL: Record<SupplyStatus, string> = {
  CONTRATADO: 'Contratado',
  NAO_CONTRATADO: 'Não contratado',
};
export const SITUATION_LABEL: Record<UnitSituation, string> = {
  NOVA_INSTALACAO: 'Nova Instalação',
  EM_OPERACAO: 'Em operação',
  CHURN: 'Churn',
};

export const CADASTRAL_BG = 'bg-[#f2f2f2]';
export const GRAY_BG = 'bg-[#e8e8e8]';
